import {Component, OnInit} from '@angular/core';
import {TranslationService} from "../../../../services/wrapper/translation.service";
import {BannerLayoutComponent} from "../../banner-layout.component";
import {BannerContentModel} from "../banner-content.model";
import {BsModalService} from "ngx-bootstrap";
import {NotificationService} from "../../../../services/common/notification.service";
import {MyStorageService} from "../../../../services/common/my-storage.service";

@Component({
    selector: 'app-title-desc-and-link-content',
    templateUrl: './title-desc-and-link-content.component.html',
    styleUrls: ['./title-desc-and-link-content.component.scss']
})
export class TitleDescAndLinkContentComponent extends BannerLayoutComponent<BannerContentModel> implements OnInit {
    title = '';
    linkText = '';
    link = '';
    description = '';


    constructor(myStorageService:MyStorageService, translationService: TranslationService, modalService: BsModalService, notificationService: NotificationService) {
        super( translationService, modalService, notificationService, myStorageService,);
    }

    ngOnInit(): void {
        this.title = this.translate(this.data.title);
        this.linkText = this.translate(this.data.linkText);
        this.link = this.translate(this.data.link);
        this.description = this.translate(this.data.description);
    }

    navigate() {
        alert(this.link);
    }

}
